// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class PublicNoteService {
   $http: any
   endpoint: any
   constructor($http: any) {
      this.getNotes = this.getNotes.bind(this)
      this.$http = $http
      this.endpoint = '/public_notes'
   }

   getNotes(dbids: any, ssids: any) {
      return this.$http.get(this.endpoint, {params: { databases: dbids, titles: ssids }})
   }
}

PublicNoteService.$inject = ['$http']

angular.module('summonApp.services')
   .service('publicNoteService', PublicNoteService)
